export default __webpack_public_path__ + "static/media/40k.69d384ce.yaml";